// extracted by mini-css-extract-plugin
export default {"dates":"hotelCardDates-module__dates__wtA0R","moonIcon":"hotelCardDates-module__moonIcon__SJ+LB"};